"use client";
import { NextFont } from "next/dist/compiled/@next/font";
import { QueryClient, QueryClientProvider } from "react-query";
import { injectStyle } from "react-toastify/dist/inject-style";
import store from "@/redux/store";
import { Provider } from "react-redux";
import React from "react";
import Theme from "./theme";
import { SnackbarProvider } from "@/components/Common/Snackbar/SnackbarContext";
import { ScrollProvider } from "@/hooks/useScroll";

const queryClient = new QueryClient({});

// CALL IT ONCE IN YOUR APP
if (typeof window !== "undefined") {
  injectStyle();
}

export default function Configure({
  inter,
  child,
}: {
  child: React.ReactNode;
  inter: NextFont;
}) {

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider>
          <ScrollProvider>
            <Theme inter={inter} child={child} />
          </ScrollProvider>
        </SnackbarProvider>
      </QueryClientProvider>
    </Provider>
  );
}

